import {
  ApiDataAccess,
  Dictionary,
  HttpApiCollectionRepository, HttpApiRepository,
  Result,
} from '@softline/core';
import { inject, Injectable } from '@angular/core';
import { WeightReport } from '../types/weight-report.model';
import { SOFTLINE_API_GEWICHTSPORTAL } from '../gewichtsportal.api';

@Injectable()
export class ReportRepository extends HttpApiRepository<
  WeightReport,
  Result<WeightReport>,
  undefined,
  undefined
> {
  constructor() {
    super(inject(ApiDataAccess), SOFTLINE_API_GEWICHTSPORTAL);
  }

  protected override getCRUDPathParams(params: any): Dictionary<unknown> | undefined {
    return undefined;
  }
}
